module.exports = __webpack_public_path__ + "img/withdraw1.5b034292.jpg";